
/**
 * Представляет ключевую точку желаемого маршрута, который задает пользователь.
 */
class RouteRequestPoint {
  /** @param {Object} data
   * @param {City} data.city
   * @param {Region} data.region
   * @param {Country} data.country
   * @param {GeoPoint} data.geoPoint
   * @param {boolean} data.isCenterCityPoint
   * @param {boolean} data.isStartPoint
   * @param {boolean} data.isEndPoint
   * @param {boolean} data.isIntermediatePoint
   * @param {boolean} data.isLoadingPoint
   * @param {boolean} data.isUnloadingPoint
   * */
  constructor({
                city = undefined,
                region = undefined,
                country = undefined,
                geoPoint = undefined,
                isCenterCityPoint = false,
                isStartPoint = false,
                isEndPoint = false,
                isIntermediatePoint = false,
                isLoadingPoint = false,
                isUnloadingPoint = false
              } = {}) {
    /** @type {City} */
    this.city = city;
    /** @type {Region} */
    this.region = region;
    /** @type {Country} */
    this.country = country;
    /** @type {GeoPoint} */
    this.geoPoint = geoPoint;
    /** @type {boolean} */
    this.isCenterCityPoint = isCenterCityPoint;
    /** @type {boolean} */
    this.isStartPoint = isStartPoint;
    /** @type {boolean} */
    this.isEndPoint = isEndPoint;
    /** @type {boolean} */
    this.isIntermediatePoint = isIntermediatePoint;
    /** @type {boolean} */
    this.isLoadingPoint = isLoadingPoint;
    /** @type {boolean} */
    this.isUnloadingPoint = isUnloadingPoint;
  }

  /** @returns {number | undefined} */
  getCityId() {
    return this.city ? this.city.id : undefined;
  }
  
  isEmpty() {
    return !this.city && !this.geoPoint;
  }

  /** @returns {number | undefined} */
  getCountryId() {
    return this.country ? this.country.id : undefined;
  }
}

export default RouteRequestPoint;